import React, { useContext, useState, useEffect, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { EstabelecimentosContext } from "../../../shared/contexts/EstabelecimentosContext";
import styles from "./Configuracoes.module.css";
import SideBarGestaoAdmin from "../components/SideBarGestaoAdmin";
import MobileMenu from "../../../shared/components/MobileMenu";
import HeaderAdmin from "../components/HeaderAdmin";
import AtendimentoWhatsapp from "../components/AtendimentoWhatsapp";
import Input from "../../../shared/form/Input";
import BtnSairConta from "../../../shared/components/BtnSairConta";
import { getAreaUrl } from "../../../shared/utils/subdomain";
import { abrirEmbeddedSignup, embeddedSignupConfigurado } from "../../../shared/utils/whatsappEmbeddedSignup";
import { Link } from "react-router-dom";
import { MdFileUpload, MdEdit, MdFileDownload, MdStorefront, MdContentCopy, MdRefresh, MdOutlineChat, MdCheckCircle, MdPrint } from "react-icons/md";

function Configuracoes() {
  const { estabelecimentos, loading, fetchEstabelecimentos } = useContext(EstabelecimentosContext);
  const [estabelecimento, setEstabelecimento] = useState(null);
  const [editando, setEditando] = useState(false);
  const [financeiroAberto, setFinanceiroAberto] = useState(false);
  const [nome, setNome] = useState("");
  const [endereco, setEndereco] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [banco, setBanco] = useState("");
  const [agencia, setAgencia] = useState("");
  const [conta, setConta] = useState("");
  const [logo, setLogo] = useState("");
  const [arquivoLogo, setArquivoLogo] = useState(null);
  const [horarioAbertura, setHorarioAbertura] = useState("");
  const [horarioFechamento, setHorarioFechamento] = useState("");
  const [pinCozinha, setPinCozinha] = useState("");
  const [regenerandoPin, setRegenerandoPin] = useState(false);
  const [linkCopiado, setLinkCopiado] = useState(false);
  const [whatsappConectado, setWhatsappConectado] = useState(false);
  const [whatsappDisplayNumber, setWhatsappDisplayNumber] = useState("");
  const [whatsappPhoneNumberId, setWhatsappPhoneNumberId] = useState("");
  const [whatsappAccessToken, setWhatsappAccessToken] = useState("");
  const [whatsappDisplayInput, setWhatsappDisplayInput] = useState("");
  const [salvandoWhatsapp, setSalvandoWhatsapp] = useState(false);
  const [conectandoMeta, setConectandoMeta] = useState(false);
  const [aceitaPix, setAceitaPix] = useState(false);
  const [chavePix, setChavePix] = useState("");
  const [salvandoPix, setSalvandoPix] = useState(false);
  const [mpConectado, setMpConectado] = useState(false);
  const [processandoMp, setProcessandoMp] = useState(false);
  const qrCanvasRef = useRef(null);

  const abrirFinanceiro = () => {
    setFinanceiroAberto(!financeiroAberto);
    console.log("Financeiro aberto:", !financeiroAberto);
  }
  
  const mudarStatusEstabelecimento = async (novoStatus) => {
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/status`, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ status_aberto: novoStatus })
      });
      const data = await response.json();
      console.log(data);
      alert("O status foi atualizado com sucesso");
      await fetchEstabelecimentos();
    } catch (error) {
      console.log("Erro ao atualizar status", error);
    }
  };

  const atualizarHorario = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/horario`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            hora_abertura: horarioAbertura,
            hora_fechamento: horarioFechamento,
          }),
        }
      );
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      alert("Horário atualizado com sucesso!");
      await fetchEstabelecimentos();
    } catch (error) {
      console.log("Erro ao atualizar horário:", error);
      alert("Erro ao atualizar horário");
    }
  };

  const baixarQrCode = () => {
    const canvas = qrCanvasRef.current;
    if (!canvas) return;
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `qrcode-${(nome || "estabelecimento").replace(/\s+/g, "-").toLowerCase()}.png`;
    link.click();
  };

  // O backend monta o link do Mercado Pago (com um `state` assinado que
  // identifica o estabelecimento) e, na volta, redireciona pra cá com ?mp=.
  const conectarMercadoPago = async () => {
    setProcessandoMp(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/mercadopago/conectar`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      if (!response.ok || !data.url) throw new Error(data.error || "Erro ao conectar Mercado Pago");
      window.location.href = data.url;
    } catch (error) {
      console.error("Erro ao conectar Mercado Pago:", error);
      alert(error.message || "Erro ao conectar Mercado Pago.");
      setProcessandoMp(false);
    }
  };

  const desconectarMercadoPago = async () => {
    if (!window.confirm("Desconectar o Mercado Pago? O Pix do WhatsApp volta a usar a chave Pix fixa (se houver).")) return;

    setProcessandoMp(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/mercadopago`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Erro ao desconectar Mercado Pago");
      setMpConectado(false);
      await fetchEstabelecimentos();
    } catch (error) {
      console.error("Erro ao desconectar Mercado Pago:", error);
      alert(error.message || "Erro ao desconectar Mercado Pago.");
    } finally {
      setProcessandoMp(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const resultadoMp = params.get("mp");
    if (!resultadoMp) return;

    alert(resultadoMp === "conectado"
      ? "Mercado Pago conectado! O Pix do WhatsApp agora é automático."
      : "Não foi possível conectar o Mercado Pago. Tente de novo.");
    params.delete("mp");
    const resto = params.toString();
    window.history.replaceState(null, "", `${window.location.pathname}${resto ? `?${resto}` : ""}`);
  }, []);

  useEffect(() => {
    const estabelecimentoId = localStorage.getItem('estabelecimento_id');

    if (estabelecimentos.length > 0 && estabelecimentoId && estabelecimentoId !== "null" && estabelecimentoId !== "undefined") {
      // Buscar o estabelecimento selecionado pelo ID
      const est = estabelecimentos.find(
        e => String(e.id_estabelecimento) === String(estabelecimentoId)
      );

      if (est) {
        setEstabelecimento(est);
        setNome(est.nomeEstabelecimento || "");
        setEndereco(est.endereco || "");
        setTelefone(est.telefone || "");
        setEmail(est.email || "");
        setBanco(est.banco || "");
        setAgencia(est.agencia || "");
        setConta(est.conta || "");
        setLogo(est.logo || "");
        setPinCozinha(est.pin_cozinha || "");
        setWhatsappConectado(!!est.whatsapp_phone_number_id);
        setWhatsappDisplayNumber(est.whatsapp_display_phone_number || "");
        setAceitaPix(!!est.whatsapp_aceita_pix);
        setChavePix(est.whatsapp_chave_pix || "");
        setMpConectado(!!est.mercadopago_conectado);
      }
    }
  }, [estabelecimentos]);

  const conectarWhatsapp = async (e) => {
    e.preventDefault();

    if (!whatsappPhoneNumberId.trim() || !whatsappAccessToken.trim()) {
      alert("Informe o Phone Number ID e o Access Token.");
      return;
    }

    setSalvandoWhatsapp(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/whatsapp`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          whatsapp_phone_number_id: whatsappPhoneNumberId.trim(),
          whatsapp_access_token: whatsappAccessToken.trim(),
          whatsapp_display_phone_number: whatsappDisplayInput.trim() || null
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Erro ao conectar WhatsApp");

      setWhatsappConectado(true);
      setWhatsappDisplayNumber(data.whatsapp_display_phone_number || "");
      setWhatsappAccessToken("");
      alert("WhatsApp conectado com sucesso!");
      await fetchEstabelecimentos();
    } catch (error) {
      console.error("Erro ao conectar WhatsApp:", error);
      alert(error.message || "Erro ao conectar WhatsApp.");
    } finally {
      setSalvandoWhatsapp(false);
    }
  };

  const conectarWhatsappMeta = async () => {
    setConectandoMeta(true);
    try {
      const dadosMeta = await abrirEmbeddedSignup();

      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/whatsapp/embedded-signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(dadosMeta)
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Erro ao conectar WhatsApp");

      setWhatsappConectado(true);
      setWhatsappDisplayNumber(data.whatsapp_display_phone_number || "");
      alert("WhatsApp conectado com sucesso!");
      await fetchEstabelecimentos();
    } catch (error) {
      console.error("Erro ao conectar WhatsApp:", error);
      alert(error.message || "Erro ao conectar WhatsApp.");
    } finally {
      setConectandoMeta(false);
    }
  };

  const salvarPixWhatsapp = async (e) => {
    e.preventDefault();

    if (aceitaPix && !mpConectado && !chavePix.trim()) {
      alert("Conecte o Mercado Pago ou informe a chave Pix.");
      return;
    }

    setSalvandoPix(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/whatsapp/pix`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          whatsapp_aceita_pix: aceitaPix,
          whatsapp_chave_pix: chavePix.trim()
        })
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Erro ao salvar Pix");

      alert("Configuração de Pix salva!");
      await fetchEstabelecimentos();
    } catch (error) {
      console.error("Erro ao salvar Pix:", error);
      alert(error.message || "Erro ao salvar configuração de Pix.");
    } finally {
      setSalvandoPix(false);
    }
  };

  const urlTelaCozinha = getAreaUrl("operador", "/telacozinha");

  const copiarUrlCozinha = async () => {
    try {
      await navigator.clipboard.writeText(urlTelaCozinha);
      setLinkCopiado(true);
      setTimeout(() => setLinkCopiado(false), 2000);
    } catch (error) {
      console.error("Erro ao copiar link:", error);
    }
  };

  const regenerarPinCozinha = async () => {
    if (!window.confirm("Gerar um novo PIN vai desconectar qualquer tablet/TV que já esteja usando o PIN atual. Continuar?")) return;

    setRegenerandoPin(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/estabelecimentos/${estabelecimento.id_estabelecimento}/pin-cozinha/regenerar`, {
        method: "POST",
        headers: { "Authorization": `Bearer ${token}` },
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error);

      setPinCozinha(data.pin_cozinha);
      await fetchEstabelecimentos();
      alert(`Novo PIN gerado: ${data.pin_cozinha}`);
    } catch (error) {
      console.error("Erro ao gerar novo PIN:", error);
      alert("Erro ao gerar novo PIN da cozinha.");
    } finally {
      setRegenerandoPin(false);
    }
  };

  const handleUploadLogo = async () => {
    if (!arquivoLogo) {
      alert("Selecione uma imagem primeiro!");
      return;
    }

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("logo", arquivoLogo);

      const res = await fetch(`${API_URL}/estabelecimento/${estabelecimento.id_estabelecimento}/logo`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const data = await res.json();
      if (data.success) {
        setLogo(data.logo);
        setArquivoLogo(null);
        alert("Logo atualizada com sucesso!");
        // Atualizar o contexto se necessário
        window.location.reload();
      } else {
        alert("Erro ao atualizar logo: " + data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Erro ao fazer upload da logo.");
    }
  };

  const handleSalvar = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_URL}/atualizar-estabelecimento`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: estabelecimento.id_estabelecimento,
          nomeEstabelecimento: nome,
          endereco,
          telefone,
          email,
        }),
      });

      const data = await res.json();
      if (data.success) {
        alert("Informações atualizadas com sucesso!");
        setEditando(false);
      } else {
        alert("Erro ao atualizar: " + data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Erro ao atualizar informações.");
    }
  };

  if (loading) return <p className={styles.msg}>Carregando...</p>;
  if (!estabelecimento) return <p className={styles.msg}>Nenhum estabelecimento encontrado. Verifique se seu estabelecimento está cadastrado.</p>;

  const estaAberto = (() => {
    if (estabelecimento.fechamento_manual) {
      return estabelecimento.status_aberto === "aberto";
    }
    const abertura = estabelecimento.hora_abertura;
    const fechamento = estabelecimento.hora_fechamento;
    if (!abertura || !fechamento) return false;
    const agora = new Date();
    const horaAtual =
      agora.getHours().toString().padStart(2, "0") + ":" +
      agora.getMinutes().toString().padStart(2, "0");
    return horaAtual >= abertura.slice(0, 5) && horaAtual < fechamento.slice(0, 5);
  })();

  return (
    <div className={styles.wrapperDashboard}>
      <MobileMenu />
      <SideBarGestaoAdmin />
      <div className={styles.containerDashboard}>
        <HeaderAdmin />
        <div className={styles.contentDashboard}>
          <div className={styles.mainColumn}>

            {/* Card principal com duas colunas */}
            <div className={styles.cardConfiguracao}>
              <div className={styles.cardContent}>
                {/* Coluna da Logo */}
                <div className={styles.logoColumn}>
                  <h3 className={styles.sectionTitle}>Logo do Estabelecimento</h3>
                  <label className={styles.logoPreviewClickable}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setArquivoLogo(e.target.files[0])}
                      className={styles.fileInputHidden}
                    />
                    {logo ? (
                      <img
                        src={`${process.env.REACT_APP_API_URL || 'http://localhost:3002'}${logo}`}
                        alt="Logo do estabelecimento"
                        className={styles.logoImage}
                      />
                    ) : (
                      <div className={styles.logoPlaceholder}>
                        <MdStorefront className={styles.placeholderIcon} />
                      </div>
                    )}
                  </label>
                  <div className={styles.uploadSection}>
                    <span className={styles.uploadText}>
                      {arquivoLogo ? arquivoLogo.name : "nenhum ficheiro selecionado"}
                    </span>
                    <button
                      onClick={handleUploadLogo}
                      className={styles.btnUpload}
                      disabled={!arquivoLogo}
                    >
                      <MdFileUpload /> Atualizar Logo
                    </button>
                  </div>
                </div>

                {/* Divisor vertical */}
                <div className={styles.dividerVertical}></div>

                {/* Coluna das Informações */}
                <div className={styles.infoColumn}>
                  <h3 className={styles.sectionTitle}>Informações do Estabelecimento</h3>

                  <div className={styles.infoGrid}>
                    <div className={styles.infoItem}>
                      <span className={styles.infoLabel}>NOME DO ESTABELECIMENTO</span>
                      {editando ? (
                        <Input
                          type="text"
                          name="nome"
                          placeholder="Nome do estabelecimento"
                          handleOnChange={(e) => setNome(e.target.value)}
                          value={nome}
                        />
                      ) : (
                        <span className={styles.infoValue}>{nome || "-"}</span>
                      )}
                    </div>

                    <div className={styles.infoItem}>
                      <span className={styles.infoLabel}>ENDEREÇO</span>
                      {editando ? (
                        <Input
                          type="text"
                          name="endereco"
                          placeholder="Endereço completo"
                          handleOnChange={(e) => setEndereco(e.target.value)}
                          value={endereco}
                        />
                      ) : (
                        <span className={styles.infoValue}>{endereco || "-"}</span>
                      )}
                    </div>

                    <div className={styles.infoItem}>
                      <span className={styles.infoLabel}>TELEFONE</span>
                      {editando ? (
                        <Input
                          type="text"
                          name="telefone"
                          placeholder="(11) 12345-6789"
                          handleOnChange={(e) => setTelefone(e.target.value)}
                          value={telefone}
                        />
                      ) : (
                        <span className={styles.infoValue}>{telefone || "-"}</span>
                      )}
                    </div>

                    <div className={styles.infoItem}>
                      <span className={styles.infoLabel}>E-MAIL DE CONTATO</span>
                      {editando ? (
                        <Input
                          type="email"
                          name="email"
                          placeholder="contato@estabelecimento.com"
                          handleOnChange={(e) => setEmail(e.target.value)}
                          value={email}
                        />
                      ) : (
                        <span className={styles.infoValue}>{email || "-"}</span>
                      )}
                    </div>
                  </div>

                  <div className={styles.editButtonContainer}>
                    {editando ? (
                      <div className={styles.editActions}>
                        <button className={styles.btnCancelar} onClick={() => setEditando(false)}>
                          Cancelar
                        </button>
                        <button className={styles.btnSalvar} onClick={handleSalvar}>
                          Salvar Alterações
                        </button>
                      </div>
                    ) : (
                      <button className={styles.btnEditarOutline} onClick={() => setEditando(true)}>
                        <MdEdit /> Editar Informações
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>


            {/* Controle de Funcionamento */}
            <div className={styles.controleFuncionamento}>
              <div className={styles.funcionamentoHeader}>
                <h3 className={styles.funcTitle}>Funcionamento</h3>
                <span className={estaAberto ? styles.badgeAberto : styles.badgeFechado}>
                  {estaAberto ? "Aberto" : "Fechado"}
                </span>
              </div>

              <div className={styles.horarios}>
                <div className={styles.grupoHorario}>
                  <label>Abertura</label>
                  <input type="time" value={horarioAbertura} onChange={(e) => setHorarioAbertura(e.target.value)} />
                </div>
                <div className={styles.grupoHorario}>
                  <label>Fechamento</label>
                  <input type="time" value={horarioFechamento} onChange={(e) => setHorarioFechamento(e.target.value)} />
                </div>
              </div>

              <div className={styles.funcionamentoBotoes}>
                <button
                  className={styles.btnSalvarHorario}
                  onClick={atualizarHorario}
                  disabled={!horarioAbertura || !horarioFechamento}
                >
                  Salvar
                </button>
                <button
                  className={styles.btnFechar}
                  onClick={() => mudarStatusEstabelecimento("fechado")}
                >
                  Fechar
                </button>
              </div>
            </div>



            {/* Tela da Cozinha */}
            <div className={styles.cardConta}>
              <div className={styles.contaContent}>
                <div className={styles.contaInfo}>
                  <h3 className={styles.contaTitle}>Tela da Cozinha</h3>
                  <p className={styles.contaDescription}>
                    Abra este link num tablet ou TV fixo na cozinha e digite o PIN abaixo uma única vez para ver os pedidos em tempo real.
                  </p>
                  <p className={styles.contaDescription} style={{ wordBreak: "break-all" }}>
                    {urlTelaCozinha}
                  </p>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 10 }}>
                  <span style={{ fontSize: "1.6rem", fontWeight: 800, letterSpacing: "0.15em", color: "var(--ink)" }}>
                    {pinCozinha || "------"}
                  </span>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button className={styles.btnEditarOutline} onClick={copiarUrlCozinha}>
                      <MdContentCopy /> {linkCopiado ? "Copiado!" : "Copiar link"}
                    </button>
                    <button className={styles.btnEditarOutline} onClick={regenerarPinCozinha} disabled={regenerandoPin}>
                      <MdRefresh /> {regenerandoPin ? "Gerando..." : "Gerar novo PIN"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Impressão automática (Speed Order Print) */}
            <div className={styles.cardConta}>
              <div className={styles.contaContent}>
                <div className={styles.contaInfo}>
                  <h3 className={styles.contaTitle}>
                  Impressão automática
                  </h3>
                  <p className={styles.contaDescription}>
                    Faça os pedidos confirmados saírem sozinhos na impressora do restaurante, usando um computador Windows ou um celular/tablet Android.
                  </p>
                </div>
                <Link to="/admin/impressao" className={styles.btnEditarOutline} style={{ textDecoration: "none" }}>
                  <MdPrint /> Configurar
                </Link>
              </div>
            </div>

            {/* Mercado Pago (Pix automático) */}
            <div className={styles.cardConta}>
              <div className={styles.contaContent}>
                <div className={styles.contaInfo}>
                  <h3 className={styles.contaTitle}>Mercado Pago</h3>
                  {mpConectado ? (
                    <p className={styles.contaDescription}>
                      <MdCheckCircle style={{ color: "green", verticalAlign: "middle" }} /> Conectado. Os Pix do WhatsApp são gerados na sua conta
                      e o pedido só vai pra cozinha depois que o pagamento é confirmado.
                    </p>
                  ) : (
                    <p className={styles.contaDescription}>
                      Conecte sua conta Mercado Pago para o Pix do WhatsApp ser automático: o cliente recebe um QR Code com o valor exato
                      e o pedido só vai pra cozinha quando o pagamento cair na sua conta — sem precisar conferir comprovante.
                    </p>
                  )}
                </div>
                {mpConectado ? (
                  <button type="button" className={styles.btnEditarOutline} onClick={desconectarMercadoPago} disabled={processandoMp}>
                    {processandoMp ? "Desconectando..." : "Desconectar"}
                  </button>
                ) : (
                  <button type="button" className={styles.btnEditarOutline} onClick={conectarMercadoPago} disabled={processandoMp}>
                    {processandoMp ? "Abrindo..." : "Conectar Mercado Pago"}
                  </button>
                )}
              </div>
            </div>

            {/* Conectar WhatsApp */}
            <div className={styles.cardConta}>
              <div className={styles.contaContent}>
                <div className={styles.contaInfo}>
                  <h3 className={styles.contaTitle}>
                    WhatsApp
                  </h3>
                  {whatsappConectado ? (
                    <p className={styles.contaDescription}>
                      <MdCheckCircle style={{ color: "green", verticalAlign: "middle" }} /> Conectado
                      {whatsappDisplayNumber ? ` — ${whatsappDisplayNumber}` : ""}. Para trocar o número, clique em "Trocar número".
                    </p>
                  ) : (
                    <p className={styles.contaDescription}>
                      Conecte o WhatsApp do seu estabelecimento para receber pedidos pelo atendimento automático.
                      Clique no botão, entre com sua conta do Facebook, digite o número do WhatsApp e confirme o código que chegar por SMS.
                    </p>
                  )}
                </div>
                <button
                  type="button"
                  className={styles.btnEditarOutline}
                  onClick={conectarWhatsappMeta}
                  disabled={conectandoMeta || !embeddedSignupConfigurado()}
                  title={embeddedSignupConfigurado() ? "" : "Conexão automática ainda não configurada no sistema"}
                >
                  <MdOutlineChat /> {conectandoMeta ? "Conectando..." : whatsappConectado ? "Trocar número" : "Conectar WhatsApp"}
                </button>
              </div>

              <details style={{ marginTop: 12 }}>
                <summary className={styles.contaDescription} style={{ cursor: "pointer" }}>Configuração manual (avançado)</summary>
              <form onSubmit={conectarWhatsapp} className={styles.formPainel} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                <Input
                  type="text"
                  text="Phone Number ID"
                  name="whatsapp_phone_number_id"
                  placeholder="Ex: 123456789012345"
                  value={whatsappPhoneNumberId}
                  handleOnChange={(e) => setWhatsappPhoneNumberId(e.target.value)}
                />
                <Input
                  type="password"
                  text="Access Token"
                  name="whatsapp_access_token"
                  placeholder="Cole o access token aqui"
                  value={whatsappAccessToken}
                  handleOnChange={(e) => setWhatsappAccessToken(e.target.value)}
                />
                <Input
                  type="text"
                  text="Número de exibição (opcional)"
                  name="whatsapp_display_phone_number"
                  placeholder="Ex: +55 11 91234-5678"
                  value={whatsappDisplayInput}
                  handleOnChange={(e) => setWhatsappDisplayInput(e.target.value)}
                />
                <button type="submit" className={styles.btnEditarOutline} disabled={salvandoWhatsapp} style={{ alignSelf: "flex-start" }}>
                  {salvandoWhatsapp ? "Salvando..." : "Salvar configuração manual"}
                </button>
              </form>
              </details>

              {/* Pix no atendimento automático */}
              <form onSubmit={salvarPixWhatsapp} className={styles.formPainel} style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 20, borderTop: "1px solid var(--panel-line)" }}>
                <h4 className={styles.contaTitle} style={{ fontSize: "1rem" }}>Pagamento via Pix no WhatsApp</h4>
                <p className={styles.contaDescription}>
                  {mpConectado
                    ? "Se ativado, o cliente pode escolher Pix ao fechar o pedido: o atendimento automático gera um QR Code do Mercado Pago com o valor exato e o pedido só vai pra cozinha depois que o pagamento for confirmado."
                    : "Se ativado, o cliente pode escolher Pix ao fechar o pedido e o atendimento automático envia a chave Pix abaixo para ele pagar. Para o Pix ser confirmado automaticamente, conecte o Mercado Pago acima."}
                </p>
                <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={aceitaPix}
                    onChange={(e) => setAceitaPix(e.target.checked)}
                  />
                  Aceitar Pix na conversa do WhatsApp
                </label>
                {aceitaPix && !mpConectado && (
                  <Input
                    type="text"
                    text="Chave Pix"
                    name="whatsapp_chave_pix"
                    placeholder="CPF/CNPJ, e-mail, telefone ou chave aleatória"
                    value={chavePix}
                    handleOnChange={(e) => setChavePix(e.target.value)}
                  />
                )}
                <button type="submit" className={styles.btnEditarOutline} disabled={salvandoPix} style={{ alignSelf: "flex-start" }}>
                  {salvandoPix ? "Salvando..." : "Salvar Pix"}
                </button>
              </form>
            </div>

            {/* Personalização do atendimento automático do WhatsApp */}
            <AtendimentoWhatsapp
              estabelecimento={estabelecimento}
              cardClassName={styles.cardConta}
              titleClassName={styles.contaTitle}
              descriptionClassName={styles.contaDescription}
              buttonClassName={styles.btnEditarOutline}
              onSalvo={fetchEstabelecimentos}
            />

            {/* Seção de Conta */}
            <div className={styles.cardConta}>
              <div className={styles.contaContent}>
                <div className={styles.contaInfo}>
                  <h3 className={styles.contaTitle}>Conta</h3>
                  <p className={styles.contaDescription}>
                    Faça logout para trocar de conta ou sair do sistema
                  </p>
                </div>
                <BtnSairConta />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Configuracoes;
